import {
  CREATE_SINGLE_JOB,
  CREATE_SINGLE_JOB_SUCCESS,
  CREATE_SINGLE_JOB_FAILURE,
  READ_SINGLE_JOB,
  READ_SINGLE_JOB_SUCCESS,
  READ_SINGLE_JOB_FAILURE,
  UPDATE_SINGLE_JOB,
  UPDATE_SINGLE_JOB_SUCCESS,
  UPDATE_SINGLE_JOB_FAILURE,
  DELETE_SINGLE_JOB,
  DELETE_SINGLE_JOB_SUCCESS,
  DELETE_SINGLE_JOB_FAILURE,
  READ_SINGLE_JOB_NOTES_LIST,
  READ_SINGLE_JOB_NOTES_LIST_SUCCESS,
  READ_SINGLE_JOB_NOTES_LIST_FAILURE,
  READ_SINGLE_JOB_NOTE,
  READ_SINGLE_JOB_NOTE_SUCCESS,
  READ_SINGLE_JOB_NOTE_FAILURE,
  CREATE_SINGLE_JOB_NOTE,
  CREATE_SINGLE_JOB_NOTE_SUCCESS,
  CREATE_SINGLE_JOB_NOTE_FAILURE,
  GET_JOB_TIME_ENTRY_LIST,
  GET_JOB_TIME_ENTRY_LIST_SUCCESS,
  GET_JOB_TIME_ENTRY_LIST_FAILURE,
  CREATE_JOB_TIME_ENTRY,
  CREATE_JOB_TIME_ENTRY_SUCCESS,
  CREATE_JOB_TIME_ENTRY_FAILURE,
  GET_SINGLE_JOB_ATTACHMENT_LIST,
  GET_SINGLE_JOB_ATTACHMENT_LIST_SUCCESS,
  GET_SINGLE_JOB_ATTACHMENT_LIST_FAILURE,
  GET_SINGLE_JOB_RECENT_ACTIVITY_LIST,
  GET_SINGLE_JOB_RECENT_ACTIVITY_LIST_SUCCESS,
  GET_SINGLE_JOB_RECENT_ACTIVITY_LIST_FAILURE,
  GET_SINGLE_JOB_ATTACHMENT_URL,
  GET_SINGLE_JOB_ATTACHMENT_URL_SUCCESS,
  GET_SINGLE_JOB_ATTACHMENT_URL_FAILURE,
  GET_SINGLE_JOB_DETAILS_FOR_TIMER,
  GET_SINGLE_JOB_DETAILS_FOR_TIMER_SUCCESS,
  GET_SINGLE_JOB_DETAILS_FOR_TIMER_FAILURE,
  GET_BILLABLE_JOB_ITEMS_LIST,
  GET_BILLABLE_JOB_ITEMS_LIST_SUCCESS,
  GET_BILLABLE_JOB_ITEMS_LIST_FAILURE,
  GET_BILLABLE_JOB_ITEM_DETAILS,
  GET_BILLABLE_JOB_ITEM_DETAILS_SUCCESS,
  GET_BILLABLE_JOB_ITEM_DETAILS_FAILURE,
  CREATE_BILLABLE_JOB_ITEM,
  CREATE_BILLABLE_JOB_ITEM_SUCCESS,
  CREATE_BILLABLE_JOB_ITEM_FAILURE,
  UPDATE_BILLABLE_JOB_ITEM,
  UPDATE_BILLABLE_JOB_ITEM_SUCCESS,
  UPDATE_BILLABLE_JOB_ITEM_FAILURE,
  DELETE_BILLABLE_JOB_ITEM,
  DELETE_BILLABLE_JOB_ITEM_SUCCESS,
  DELETE_BILLABLE_JOB_ITEM_FAILURE,
} from "./actionType";

// initial state
const INIT_STATE = {
  singleJob: [],
  singleJobLoading: false,
  // Task 24826 - the id of the job currently being READ, so a response that
  // arrives after the user has moved on can be recognised and dropped.
  singleJobRequestedId: null,
  error: null,
  singleJobNotesList: [],
  singleJobNote: [],
  singleJobNoteCreateSuccess: [],
  jobTimeEntryList: [],
  jobTimeEntryCreateSuccess: [],
  jobTimeEntryCreateLoading: false,
  singleJobAttachmentList: [],
  singleJobRecentActivityList: [],
  singleJobRecentActivityRequestedId: null,
  timeEntriesLoading: false,
  singleJobAttachmentUrl: [],
  singleJobAttachmentUrlLoading: false,
  singleJobDetailsForTimer: [],
  singleJobDetailsForTimerLoading: false,
  billableJobItemsList: [],
  billableJobItemsListLoading: false,
  billableJobItemDetails: [],
  billableJobItemDetailsLoading: false,
  billableJobItemCreateSuccess: [],
  billableJobItemCreateSuccessLoading: false,
  billableJobItemUpdateSuccess: [],
  billableJobItemUpdateSuccessLoading: false,
  billableJobItemDeleteSuccess: [],
  billableJobItemDeleteSuccessLoading: false,
};

// Single Job Reducer
const SingleJob = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CREATE_SINGLE_JOB:
      return { ...state, loading: true };
    case CREATE_SINGLE_JOB_SUCCESS:
      return { ...state, loading: false, singleJob: action.payload };
    case CREATE_SINGLE_JOB_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Task 24826 - "switching job shows the PREVIOUS job for 4-5 seconds".
    //
    // This case used to be { ...state, singleJobLoading: true } and nothing
    // else, so the old job stayed in the store for the whole of the new
    // job's round trip and every screen carried on rendering it. The API
    // speedup in Task 24731 shortened that window, it did not close it - and
    // a screen showing another job's figures confidently is worse than a
    // spinner, because someone will act on it.
    //
    // Cleared only when the job ACTUALLY CHANGES. A re-read of the same job -
    // which is what happens after a save - keeps what is on screen, so the
    // fix does not introduce a blank flash every time something is edited.
    case READ_SINGLE_JOB: {
      const requestedId = String(action.payload?.id ?? "");
      const heldId = String(state.singleJob?.job_data?.Id ?? "");
      const isDifferentJob =
        requestedId !== "" && heldId !== "" && requestedId !== heldId;

      if (!isDifferentJob) {
        return { ...state, singleJobLoading: true, singleJobRequestedId: requestedId || null };
      }

      // Everything keyed to the job goes, not just the job row. The notes,
      // time entries, attachments and activity feed are all the OLD job's and
      // are each fetched by their own request; leaving them would simply move
      // the same bug onto the tabs.
      return {
        ...state,
        singleJobLoading: true,
        singleJobRequestedId: requestedId || null,
        singleJob: [],
        singleJobNotesList: [],
        singleJobNote: [],
        jobTimeEntryList: [],
        singleJobAttachmentList: [],
        singleJobRecentActivityList: [],
        billableJobItemsList: [],
      };
    }
    case READ_SINGLE_JOB_SUCCESS: {
      // Task 24826 - drop a response for a job we are no longer looking at.
      // Switching A -> B -> A quickly can land B's response last and leave B
      // on screen under A's URL. Nothing in the store said which request a
      // response belonged to, so the last one home always won.
      const arrivedId = String(action.payload?.job_data?.Id ?? "");
      const wantedId = String(state.singleJobRequestedId ?? "");

      if (wantedId !== "" && arrivedId !== "" && arrivedId !== wantedId) {
        return state;
      }

      return { ...state, singleJobLoading: false, singleJob: action.payload };
    }
    case READ_SINGLE_JOB_FAILURE:
      return { ...state, singleJobLoading: false, error: action.payload };

    case UPDATE_SINGLE_JOB:
      return { ...state, loading: true };
    case UPDATE_SINGLE_JOB_SUCCESS:
      return { ...state, loading: false, singleJob: action.payload };
    case UPDATE_SINGLE_JOB_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_SINGLE_JOB:
      return { ...state, loading: true };
    case DELETE_SINGLE_JOB_SUCCESS:
      return { ...state, loading: false, singleJob: action.payload };
    case DELETE_SINGLE_JOB_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case READ_SINGLE_JOB_NOTES_LIST:
      return { ...state, loading: true, singleJobNotesList: action.payload };
    case READ_SINGLE_JOB_NOTES_LIST_SUCCESS:
      return { ...state, loading: false, singleJobNotesList: action.payload };

    case READ_SINGLE_JOB_NOTES_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case READ_SINGLE_JOB_NOTE:
      return { ...state, loading: true };
    case READ_SINGLE_JOB_NOTE_SUCCESS:
      return { ...state, loading: false, singleJobNote: action.payload };
    case READ_SINGLE_JOB_NOTE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_SINGLE_JOB_NOTE:
      return { ...state, loading: true };
    case CREATE_SINGLE_JOB_NOTE_SUCCESS:
      return {
        ...state,
        loading: false,
        singleJobNoteCreateSuccess: action.payload,
      };
    case CREATE_SINGLE_JOB_NOTE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_JOB_TIME_ENTRY_LIST:
      return {
        ...state,
        timeEntriesLoading: true,
        jobTimeEntryList: action.payload,
      };
    case GET_JOB_TIME_ENTRY_LIST_SUCCESS:
      return {
        ...state,
        timeEntriesLoading: false,
        jobTimeEntryList: action.payload,
      };
    case GET_JOB_TIME_ENTRY_LIST_FAILURE:
      return { ...state, timeEntriesLoading: false, error: action.payload };

    case CREATE_JOB_TIME_ENTRY:
      return { ...state, jobTimeEntryCreateLoading: true };
    case CREATE_JOB_TIME_ENTRY_SUCCESS:
      return {
        ...state,
        jobTimeEntryCreateLoading: false,
        jobTimeEntryCreateSuccess: action.payload,
      };
    case CREATE_JOB_TIME_ENTRY_FAILURE:
      return {
        ...state,
        jobTimeEntryCreateLoading: false,
        error: action.payload,
      };

    case GET_SINGLE_JOB_ATTACHMENT_LIST:
      return {
        ...state,
        loading: true,
        singleJobAttachmentList: action.payload,
      };
    case GET_SINGLE_JOB_ATTACHMENT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        singleJobAttachmentList: action.payload,
      };
    case GET_SINGLE_JOB_ATTACHMENT_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Task 24881 - "recent activity is showing data from another job".
    //
    // Same shape of bug as 24826, one level down. One of these requests is
    // fired per job and nothing said which job a response belonged to, so
    // switching A -> B could land A's response last and leave A's activity
    // sitting under B's title and id. Creating a job makes it likely, because
    // the navigation happens while the previous job's request is still out.
    case GET_SINGLE_JOB_RECENT_ACTIVITY_LIST: {
      // The old code put action.payload - the REQUEST ARGUMENT, {id: n} - into
      // the field the screen reads as a list. Harmless only by accident: the
      // UI then reads .jobrecentactivity_list off it and gets undefined. Empty
      // is what is wanted here, so say so.
      const requestedId = String(action.payload?.id ?? "");
      return {
        ...state,
        loading: true,
        singleJobRecentActivityRequestedId: requestedId || null,
        singleJobRecentActivityList: [],
      };
    }
    case GET_SINGLE_JOB_RECENT_ACTIVITY_LIST_SUCCESS: {
      const arrivedId = String(action.payload?.Job_Id ?? "");
      const wantedId = String(state.singleJobRecentActivityRequestedId ?? "");

      // Drop a list for a job we have already navigated away from. Only when
      // both ids are known - an older backend that does not echo Job_Id must
      // keep working, just without the protection.
      if (wantedId !== "" && arrivedId !== "" && arrivedId !== wantedId) {
        return state;
      }

      return {
        ...state,
        loading: false,
        singleJobRecentActivityList: action.payload,
      };
    }
    case GET_SINGLE_JOB_RECENT_ACTIVITY_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_SINGLE_JOB_ATTACHMENT_URL:
      return {
        ...state,
        singleJobAttachmentUrlLoading: true,
      };
    case GET_SINGLE_JOB_ATTACHMENT_URL_SUCCESS:
      return {
        ...state,
        singleJobAttachmentUrlLoading: false,
        singleJobAttachmentUrl: action.payload,
      };
    case GET_SINGLE_JOB_ATTACHMENT_URL_FAILURE:
      return {
        ...state,
        singleJobAttachmentUrlLoading: false,
        singleJobAttachmentUrl: action.payload,
      };

    case GET_SINGLE_JOB_DETAILS_FOR_TIMER:
      return {
        ...state,
        singleJobDetailsForTimerLoading: true,
      };

    case GET_SINGLE_JOB_DETAILS_FOR_TIMER_SUCCESS:
      return {
        ...state,
        singleJobDetailsForTimerLoading: false,
        singleJobDetailsForTimer: action.payload,
      };

    case GET_SINGLE_JOB_DETAILS_FOR_TIMER_FAILURE:
      return {
        ...state,
        singleJobDetailsForTimerLoading: false,
        singleJobDetailsForTimer: action.payload,
      };

    case GET_BILLABLE_JOB_ITEMS_LIST:
      return { ...state, billableJobItemsListLoading: true };

    case GET_BILLABLE_JOB_ITEMS_LIST_SUCCESS:
      return {
        ...state,
        billableJobItemsListLoading: false,
        billableJobItemsList: action.payload,
      };

    case GET_BILLABLE_JOB_ITEMS_LIST_FAILURE:
      return {
        ...state,
        billableJobItemsListLoading: false,
        error: action.payload,
      };

    case GET_BILLABLE_JOB_ITEM_DETAILS:
      return { ...state, billableJobItemDetailsLoading: true };

    case GET_BILLABLE_JOB_ITEM_DETAILS_SUCCESS:
      return {
        ...state,
        billableJobItemDetailsLoading: false,
        billableJobItemDetails: action.payload,
      };

    case GET_BILLABLE_JOB_ITEM_DETAILS_FAILURE:
      return {
        ...state,
        billableJobItemDetailsLoading: false,
        error: action.payload,
      };

    case CREATE_BILLABLE_JOB_ITEM:
      return { ...state, billableJobItemCreateSuccessLoading: true };

    case CREATE_BILLABLE_JOB_ITEM_SUCCESS:
      return {
        ...state,
        billableJobItemCreateSuccessLoading: false,
        billableJobItemCreateSuccess: action.payload,
      };

    case CREATE_BILLABLE_JOB_ITEM_FAILURE:
      return {
        ...state,
        billableJobItemCreateSuccessLoading: false,
        error: action.payload,
      };

    case UPDATE_BILLABLE_JOB_ITEM:
      return { ...state, billableJobItemUpdateSuccessLoading: true };

    case UPDATE_BILLABLE_JOB_ITEM_SUCCESS:
      return {
        ...state,
        billableJobItemUpdateSuccessLoading: false,
        billableJobItemUpdateSuccess: action.payload,
      };

    case UPDATE_BILLABLE_JOB_ITEM_FAILURE:
      return {
        ...state,
        billableJobItemUpdateSuccessLoading: false,
        error: action.payload,
      };

    case DELETE_BILLABLE_JOB_ITEM:
      return { ...state, billableJobItemDeleteSuccessLoading: true };

    case DELETE_BILLABLE_JOB_ITEM_SUCCESS:
      return {
        ...state,
        billableJobItemDeleteSuccessLoading: false,
        billableJobItemDeleteSuccess: action.payload,
      };

    case DELETE_BILLABLE_JOB_ITEM_FAILURE:
      return {
        ...state,
        billableJobItemDeleteSuccessLoading: false,
        error: action.payload,
      };

    default:
      return { ...state };
  }
};
export default SingleJob;
